/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyOfficeAssociateUsersToOfficeDto } from '../../models/company-office-associate-users-to-office-dto';
import { EmptyResponse } from '../../models/empty-response';

export interface OfficeControllerAssociateUsersToOffice$Params {
  id: number;
      body: CompanyOfficeAssociateUsersToOfficeDto
}

export function officeControllerAssociateUsersToOffice(http: HttpClient, rootUrl: string, params: OfficeControllerAssociateUsersToOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerAssociateUsersToOffice.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EmptyResponse;
      }>;
    })
  );
}

officeControllerAssociateUsersToOffice.PATH = '/company/office/associate/office/{id}/users';
